import {
  IProductFeatureDataViewModel,
  IProductViewModel,
} from 'Interfaces/IProductConfig';
import { CloudFactoryProductViewModel } from './ICloudFactoryInterfaces';
import { IProductTypeViewModel } from 'pages/Billing/BillingConfig';
import { IBrandViewModel } from 'pages/Setup/setupConfig';
import {
  EnumBindingPeriod,
  EnumCycleAlignment,
  EnumProductSecurity,
  EnumProductVariant,
} from 'Interfaces/IGlobalTypeConfig';
import { EnumConsumableType } from 'data/enum';

// Mapper for produkt-type
export function toProductTypeViewModel(src: any): IProductTypeViewModel {
  return {
    id: src.id,
    name: src.name,
    productCategoryName: src.productCategoryName,
    lifeExpectancy: src.LifeExpectancy,
    productFeatures: (src.productFeatures ?? []).map((f: any) => ({
      id: f.id,
      productFeatureId: f.productFeatureId,
      description: f.description,
      featureName: f.featureName,
      priority: f.priority,
      includeInDescriptiveName: f.includeInDescriptiveName,
      selectedDescription: f.selectedDescription,
    })),
  };
}

// Mapper for produkt-funksjons-data
export function toProductFeatureDataViewModel(
  src: any
): IProductFeatureDataViewModel {
  return {
    id: src.id,
    productFeatureId: src.productFeatureId,
    description: src.description,
    featureName: src.featureName,
    priority: src.priority,
    includeInDescriptiveName: src.includeInDescriptiveName,
    selectedDescription: src.selectedDescription,
  };
}

// Mapper for merke
export function toBrandViewModel(src: any): IBrandViewModel {
  return {
    id: src.id,
    brandName: src.brandName ?? src.name,
    isActive: src.isActive,
  };
}

// Hoved-mapper for produkt
export function toProductViewModel(
  p: CloudFactoryProductViewModel
): IProductViewModel {
  const prod = p.product;

  return {
    id: prod.id,
    productType: toProductTypeViewModel(prod.productType),
    features: (prod.features ?? []).map(toProductFeatureDataViewModel),
    imageFile: prod.imageFile,
    name: prod.name,
    comment: prod.comment ?? null,
    serialNumber: prod.serialNumber ?? null,
    unitPrice: prod.unitPrice,
    retailPrice: prod.retailPrice,
    security: prod.security as EnumProductSecurity,
    productVariant: prod.productVariant as EnumProductVariant,
    isConsumable: prod.isConsumable,
    consumableType: prod.consumableType as EnumConsumableType,
    isActive: prod.isActive,
    url: prod.url,
    vendorProductUrl: prod.vendorProductUrl,
    EAN: prod.EAN,
    brandId: prod.brandId,
    brand: toBrandViewModel(prod.brand),
    quantity: prod.quantity,
    paymentCycle: prod.paymentCycle as EnumBindingPeriod,
    cycleAlignment: prod.cycleAlignment as EnumCycleAlignment,
    bindingPeriod: prod.bindingPeriod as EnumBindingPeriod,
    isAlreadyBilled: prod.isAlreadyBilled,
    legacyId: prod.legacyId,
    thirdPartyId: prod.thirdPartyId,
    thirdParty: prod.thirdParty,
    created: prod.created,
  };
}
